module.exports = __webpack_public_path__ + "static/media/Passito.78fbe6d8.png";